export default __webpack_public_path__ + "static/istanbulspor-logo-58d53ab54b36e0d732be0d6ce9018675.png";